export enum EnumTabs {
  VALID = '1',
  INVALID = '0',
}
